import { render, staticRenderFns } from "./brainMains.vue?vue&type=template&id=1a4c2a22&scoped=true&"
import script from "./brainMains.vue?vue&type=script&lang=js&"
export * from "./brainMains.vue?vue&type=script&lang=js&"
import style0 from "./brainMains.vue?vue&type=style&index=0&id=1a4c2a22&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4c2a22",
  null
  
)

export default component.exports